<template>
  <div class="auth-wrapper auth-v2 p-2">
    <div class="p-2">
      <!-- Forgot password-->
      <div v-if="isValid" class="alert alert-success d-flex align-items-center" role="alert">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
          <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z"/>
          <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z"/>
        </svg>
        <span class="ms-1">We have sent the reset link to {{ userEmail }}.</span>
      </div>
      <span class="mb-2">
        Enter your e-mail address below and we will send you an e-mail to reset your password.
      </span>
      <!-- form -->
      <form
        class="auth-forgot-password-form mt-2"
        @submit.prevent="validationForm"
      >
        <div class="form-outline mb-4">
          <!-- <label for="last-name" class="text-nowrap mb-2 d-flex justify-content-start ps-0">Email</label> -->
          <input @keyup="errors.email = []" required type="text" placeholder="Email" v-model="userEmail" class="form-control">
          <small v-if="errors.email" class="text-danger">{{ errors.email[0] }}</small>
        </div>
        <div class="d-grid gap-2">
          <button class="btn btn-primary" :disabled="disableButton || isValid" type="submit">Send reset link</button>
        </div>
      </form>
      <!-- /Forgot password-->
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import "bootstrap"

export default {
  props: {
    email: String,
    isValid: Boolean,
  },
  data() {
    return {
      userEmail: '',
      errors: {
        email: [],
      },
      disableButton: false,
    }
  },
  created() {
    this.userEmail = this.email
  },
  methods: {
    validationForm() {
      this.disableButton = true
      const URL = `${process.env.VUE_APP_BASEURI}/account-setting/forgot`
      fetch(URL, {
        method: 'post',
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email: this.userEmail }),
    })
    .then(response => {
      this.disableButton = false
        response.json().then(resp => {
          if (resp.email) {
            return this.$emit('valdate-email')
          }
          if (!resp.success) {
            if (resp.errors) {
                this.errors = resp.errors
            }
          }
        })
    }).catch(err => console.log(err))
    },
  },
}
</script>
<style scoped src="../assets/bootstrap.min.css"></style>
<style scoped>
.btn-primary {
      background-color: var(--primary) !important;
      border-color: var(--primary) !important;
  }
  .btn:focus{
    box-shadow:none !important;
  }
  input {
    display: block;
  }
  input:focus {
    box-shadow:none !important;
    border-color: var(--primary) !important;
  }
</style>
